import React from 'react';
import styles from './footer.module.scss';
import logo from '../../assets/images/footer-logo.svg';
import { Link } from 'react-router-dom';
import { instagram, linkedin, twitter } from '../SVG';

export default function Footer() {
  return (
    <div className={styles['footer']}>
      <div className='auto__container'>
        <div className={styles['footer__inner']}>
          <div className={styles['footer__inner-main']}>
            <div className={styles['footer__inner-logo']}>
              <img src={logo} alt='' />
            </div>
            <div className={styles['footer__inner-row']}>
              <div className={styles['footer__inner-col']}>
                <h5>Legal</h5>
                <Link to='/terms-of-service'>Terms of Service</Link>
                <Link to='/privacy-policy'>Privacy Policy</Link>
              </div>
              <div className={styles['footer__inner-col']}>
                <h5>Socials</h5>
                <div className={styles['footer__inner-social']}>
                  <a href='https://www.instagram.com/shivon__ai/'>{instagram}</a>
                  <a href='https://x.com/Shivon_AI'>{twitter}</a>
                  <a href='https://www.linkedin.com/company/shivon-ai/'>{linkedin}</a>
                </div>
              </div>
            </div>
          </div>
          <div className={styles['footer__inner-copy']}>
            <p className='sm'>Copyright © 2024. All Rights Reserved Shivon AI</p>
          </div>
        </div>
      </div>
    </div>
  );
}